import player from './playerReducer';

export default {
  player
};
